import type { FashionModel } from '@frontend/libs/types/product'

import { parseHtml } from '@frontend/libs/utils'
import placeholder from '@images/placeholder-wide.jpg'
import {
  Button,
  cn,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  useDisclosure,
} from '@nextui-org/react'
import { __ } from '@wordpress/i18n'

export type FashionModelPopupProps = {
  fashionModels: FashionModel[]
}

export function FashionModelPopup({
  fashionModels,
}: Readonly<FashionModelPopupProps>) {
  const { isOpen, onClose, onOpen } = useDisclosure()

  if (!fashionModels?.length) {
    return <></>
  }

  return (
    <>
      <Button
        className="h-auto p-0 underline"
        onPress={onOpen}
        type="button"
        variant="light"
      >
        {__('Model Information', 'asavagroup')}
      </Button>
      <Modal
        classNames={{
          closeButton: 'rounded-none top-4 right-4 text-2xl z-20',
        }}
        isOpen={isOpen}
        onClose={onClose}
        placement="center"
        scrollBehavior="inside"
        size="5xl"
      >
        <ModalContent>
          <ModalBody className="px-14 py-16">
            <div
              className={cn(`grid justify-center gap-4 gap-y-20`, {
                'md:grid-cols-2': fashionModels?.length > 1,
              })}
            >
              {fashionModels.map((model, index) => (
                <div className="max-w-[350px] text-center" key={index}>
                  <Image
                    alt={model.image.alt}
                    className="mx-auto max-w-[200px] md:max-w-full"
                    fallbackSrc={placeholder}
                    src={model.image.sizes.full}
                    srcSet={model.image.srcset}
                  />
                  <div className="mt-6 uppercase md:text-base">
                    <h4 className="mb-2 text-3xl font-medium">{model.name}</h4>
                    <div className="mx-auto max-w-[250px]">
                      {model?.height && model.height > 0 && (
                        <span>height {model.height} cm</span>
                      )}
                      {model?.bust && model.bust > 0 && (
                        <span> | bust {model.bust} cm</span>
                      )}
                      <br />
                      {model?.waist && model.waist > 0 && (
                        <span>waist {model.waist} cm</span>
                      )}
                      {model?.hips && model.hips > 0 && (
                        <span> | hips {model.hips} cm</span>
                      )}
                    </div>
                    {model?.size && (
                      <p className="mt-8 font-medium">
                        MODEL IS WEARING A SIZE {model.size}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default FashionModelPopup
